"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hooks = void 0;
var firestore_1 = require("firebase/firestore");
var react_1 = require("react");
/**
 * A class that contains various utility functions for making API calls, handling input events,
 * and more.
 * @class
 */
exports.Hooks = {
    useFocus: function () {
        var domRef = (0, react_1.useRef)(null);
        (0, react_1.useEffect)(function () {
            var _a;
            (_a = domRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, [domRef]);
        return {
            domRef: domRef,
        };
    },
    useUserCollection: function (logic, path) {
        return __awaiter(this, void 0, void 0, function () {
            var userUid, userPath, ots;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userUid = logic.fb.getAuthenticatedUserUid();
                        userPath = userUid ? "users/".concat(userUid, "/").concat(path) : null;
                        return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collection)(logic.fb.db, "users/" + userUid + "/" + logic.fb.siteConfig.id + "/Main/" + path))];
                    case 1:
                        ots = _a.sent();
                        return [2 /*return*/, ots.docs.map(function (doc) {
                                var temp = doc.data();
                                var ots = {
                                    id: doc.id,
                                    data: temp.data,
                                };
                                return ots;
                            })];
                }
            });
        });
    },
    /**
     * A custom React Hook that provides a way to interact with the local storage of the browser.
     * It allows you to store and retrieve a value for a given key.
     * It also keeps the value in sync between multiple tabs/windows of the same origin.
     *
     * @param {string} key - The key for the local storage entry.
     *
     * @returns {string | null} The current value of the specified key in local storage.
     * If the key does not exist, or an error occurs while reading the key, null is returned.
     *
     * @example
     *
     * const storedValue = useLocalStorage('myKey');
     * // If 'myKey' is present in localStorage, its value will be stored in `storedValue`
     * // Otherwise, `storedValue` will be null
     */
    useLocalStorage: function (key) {
        var _a = (0, react_1.useState)(function () {
            try {
                return window.localStorage.getItem(key);
            }
            catch (error) {
                console.error("Error reading localStorage key \u201C".concat(key, "\u201D:"), error);
                return null;
            }
        }), value = _a[0], setValue = _a[1];
        (0, react_1.useEffect)(function () {
            var onStorageChange = function (e) {
                if (e.key === key) {
                    setValue(e.newValue);
                }
            };
            window.addEventListener("storage", onStorageChange);
            return function () {
                window.removeEventListener("storage", onStorageChange);
            };
        }, [key]);
        return value;
    },
    /**
     * A custom hook that handles asynchronous operations inside a useEffect loop.
     * It ensures that the async function is only called when the specified dependencies change,
     * and it properly handles cleanup when the component is unmounted.
     *
     * @param {Function} asyncFunction - The asynchronous function to be called inside useEffect.
     * @param {Array} dependencies - An array of dependencies for the useEffect hook.
     */
    useAsyncEffect: function (asyncFunction, dependencies) {
        (0, react_1.useEffect)(function () {
            var isMounted = true;
            var wrappedAsyncFunction = function () { return __awaiter(void 0, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, asyncFunction()];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            if (isMounted) {
                                console.error("An error occurred in useAsyncEffect:", error_1);
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            wrappedAsyncFunction();
            return function () {
                isMounted = false;
            };
        }, dependencies);
    },
};
